import { Directive, Input, HostListener } from '@angular/core';
import { TreeWrapperNode } from '../models/tree-wrapper-node.model';

/**
 * Directiva placeholder para drag functionality
 * Mantiene compatibilidad con el template original pero no implementa funcionalidad completa
 */
@Directive({
    selector: '[treeDrag]',
    standalone: false
})
export class TreeDragDirective {
  @Input() treeDrag: TreeWrapperNode;
  @Input() treeDragEnabled: boolean = false;

  @HostListener('dragstart', ['$event'])
  onDragStart(event: DragEvent): void {
    if (!this.treeDragEnabled) {
      event.preventDefault();
      return;
    }
    // Implementación futura para drag
  }
}

